import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import QuizPageText from '../components/QuizPageText/QuizPageText';
import { guidesPageText } from '../components/QuizPageText/quizPageText.data';
import animeConfig from '../config/animeConfig';
import './Guides.css';

const GuidesIndex = () => {
  const navigate = useNavigate();
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };
  return (
    <>
      <Helmet>
        <title>One Piece Guides: Straw Hat Crew, Devil Fruits, Characters</title>
        <meta name="description" content="Short One Piece guides: the ten Straw Hats and their roles, how the three Devil Fruit types work, and the Emperors, Warlords and Marines who drive the story." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/guides" />
        <meta property="og:title" content="One Piece Guides: Straw Hat Crew, Devil Fruits, Characters" />
        <meta property="og:description" content="One Piece fan guides covering Devil Fruits, the Straw Hat crew, story arcs and more." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/guides" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
      <div className="guide-container">
        <h1>One Piece Guides</h1>
        <p className="guide-intro">
          Short fan guides. Each one ends with a quiz so you can test what you read.
        </p>

        <p className="guide-intro">
          Three guides so far. The crew guide covers all ten Straw Hats, what each one
          does on the ship and the moment they joined. The Devil Fruit guide explains
          Paramecia, Zoan and Logia, why a Logia is so hard to hit, and what awakening
          changes. The character guide runs through the Emperors, the Warlords, the
          Marine admirals and the rivals who keep turning up. If you would rather be
          tested than read, the{' '}
          <Link to="/devil-fruit-quiz">Devil Fruit Quiz</Link> names a fruit and asks
          who ate it, and the{' '}
          <Link to="/quiz">Character Quiz</Link> shows a face and asks who it is.
        </p>

        <ul className="guide-index-list">
          <li>
            <Link to="/guides/straw-hat-crew">
              <h2>The Straw Hat Pirates</h2>
              <p>All 10 crew members, their roles, and what they bring to the ship.</p>
            </Link>
          </li>
          <li>
            <Link to="/guides/devil-fruits">
              <h2>Devil Fruits Explained</h2>
              <p>The three types, the most powerful fruits in the story, and who eats what.</p>
            </Link>
          </li>
          <li>
            <Link to="/guides/characters">
              <h2>Allies, Enemies and Legends</h2>
              <p>The Emperors, Warlords, Marines, and rivals who drive the story forward.</p>
            </Link>
          </li>
        </ul>

        <div className="guide-cta">
          <h2>Play a Quiz</h2>
          <div className="guide-games-row">
            <button className="guide-game-btn" onClick={() => navigate('/quiz')}>
              <img src="/character-quiz-and-any-related.png" alt="" className="guide-game-icon" />
              <span>Character Quiz</span>
            </button>
            <button className="guide-game-btn" onClick={() => navigate('/image-quiz')}>
              <img src="/image-quiz-and-any-related.png" alt="" className="guide-game-icon" />
              <span>Image Quiz</span>
            </button>
            <button className="guide-game-btn" onClick={() => navigate('/devil-fruit-quiz')}>
              <img src="/devil-fruit-quiz-and-any-related.png" alt="" className="guide-game-icon" />
              <span>Devil Fruit Quiz</span>
            </button>
            <button className="guide-game-btn" onClick={() => navigate('/bounty-battle')}>
              <span className="guide-game-icon game-emoji" aria-hidden="true">💰</span>
              <span>Bounty Battle</span>
            </button>
            <button className="guide-game-btn" onClick={() => navigate('/puzzle')}>
              <span className="guide-game-icon game-emoji" aria-hidden="true">🧩</span>
              <span>Jigsaw Puzzle</span>
            </button>
          </div>
        </div>
      </div>
      </div>
      <QuizPageText {...guidesPageText} />
    </>
  );
};

export default GuidesIndex;
